import styled from 'styled-components'
import { colors } from 'styles/theme'

export const Container = styled.section`
  border-radius: ${({ theme }) => theme.borderRadiuses.normal};
  border: 1px solid ${({ theme }) => theme.colors.borderLight};
  box-shadow: ${({ theme }) => theme.shadows.standard};
  display: flex;
  flex-grow: 1;
  justify-content: space-between;
  padding: 15px 20px;
`
export const Name = styled.h2`
  color: ${({ theme }) => theme.colors.text};
  font-size: 20px;
  font-weight: bold;
  line-height: 26px;
  margin: 0 0 10px 0;
`
export const DateWrapper = styled.p`
  color: ${({ theme }) => theme.colors.text};
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  margin: 0;
`
export const Button = styled.button`
  background: ${({ theme }) => theme.colors.main};
  border-radius: 4px;
  border: none;
  color: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  font-size: 12px;
  font-weight: bold;
  height: 35px;
  line-height: 16px;
  margin-left: 17px;
  text-transform: uppercase;
  width: 165px;

  :disabled {
    background-color: ${({ theme }) => theme.colors.backgroundDisabled};
    border: 1px solid ${({ theme }) => theme.colors.backgroundSecondary};
    color: ${({ theme }) => theme.colors.black};
    cursor: not-allowed;
  }
`
export const Group = styled.div`
  align-items: center;
  display: flex;
`
export const selectStyles = {
  container: (styles: any) => ({
    ...styles,
    height: '35px',
  }),
  control: (styles: any) => ({
    ...styles,
    width: 200,
    border: `1px solid ${colors.backgroundSecondary}`,
    height: '35px',
    minHeight: '35px',
  }),
  input: (styles: any) => ({
    ...styles,
    margin: 0,
    color: colors.black,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
  }),
  singleValue: (styles: any) => ({
    ...styles,
    color: colors.black,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
  }),
  option: (styles: any) => ({
    ...styles,
    color: colors.black,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '18px',
  }),
  dropdownIndicator: (styles: any) => ({
    ...styles,
    color: colors.black,
  }),
  valueContainer: (styles: any) => ({
    ...styles,
    height: '35px',
    padding: '0 6px',
  }),
  indicatorsContainer: (styles: any) => ({
    ...styles,
    height: '35px',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
}
export const selectTheme = (theme: any) => ({
  ...theme,
  colors: {
    ...colors,
    text: colors.black,
    primary: colors.main,
  },
})

export const LastSaved = styled.div`
  color: ${({ theme }) => theme.colors.black};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  margin-right: 20px;
  display: flex;
  align-items: center;
`
